<template>
	<div class="tabs" v-bind="$attrs">
		<button
				v-for="tab in tabItems"
				:key="tab.id"
				:class="['tab', { active: currentTab === tab.id, disabled: tab.disabled }]"
				@click="handleTabClick(tab)"
		>
			<Icon v-if="tab.icon" :name="tab.icon" size="md" class="tab-icon"/>
			<span class="tab-label">{{ tab.label }}</span>
		</button>
	</div>
	
	<Modal
			:show="showGroupsModal"
			confirm-text="Got it"
			:cancel-text="null"
			:close-on-overlay="true"
			@close="showGroupsModal = false"
			@confirm="showGroupsModal = false"
	>
		<div class="coming-soon-modal">
			<Icon name="tv-groups" size="xl"/>
			<h3>Coming Soon!</h3>
			<p>Group management and batch-control features are on the way.</p>
		</div>
	</Modal>
</template>

<script setup>
import Icon from './Icon.vue'
import Modal from "@/components/Modal.vue";
import {ref} from "vue";

const emit = defineEmits(['change'])

const currentTab = ref('devices')
const showGroupsModal = ref(false)
const tabItems = [
	{id: 'devices', label: 'Displays', icon: 'tv'},
	{id: 'groups', label: 'Groups', icon: 'tv-groups', disabled: true}
]

const handleTabClick = (tab) => {
	if (tab.disabled) {
		if (tab.id === 'groups') {
			showGroupsModal.value = true
		}
		return
	}
	
	currentTab.value = tab.id
	emit('change', tab.id)
}
</script>

<style scoped>
.tabs {
	display: flex;
	justify-content: space-between;
	width: 100%;
	gap: var(--spacing-md);
	position: relative;
	top: 0;
	z-index: 1;
}

.tab {
	flex: 1;
	display: inline-flex;
	align-items: center;
	justify-content: center;
	gap: var(--spacing-sm);
	border: none;
	background: transparent;
	font-weight: var(--font-weight-semibold);
	cursor: pointer;
	transition: all var(--transition-fast);
	filter: drop-shadow(var(--shadow-md));
	color: var(--color-text);
}

.tab.active {
	background: var(--color-primary-2);
	opacity: 1;
}

.tab.disabled {
	opacity: 0.6;
	cursor: not-allowed;
	background: var(--color-surface-2);
}
</style>